/**
 * Deep links into the host's availability patterns, the mirror of
 * {@link import("../booking/links").rollingLinkLinkFor}.
 *
 * <p>A rolling link owns a pattern, and the two are shown to each other (D-88). Both halves of
 * that walk are deep links: the builder points at the one pattern it minted, and that pattern's
 * card points back at the one link that owns it. The anchor ids live here so the side that writes
 * the link and the side that renders the target cannot drift apart.</p>
 */

/** The patterns section as a whole — "Edit availability" from a builder lands here. */
export const AVAILABILITY_PATTERNS_SECTION_ID = "availability-patterns";

/** One pattern card. Distinct from the section id above (singular, plus the id). */
export function availabilityPatternAnchorId(patternId: string): string {
  return `availability-pattern-${patternId}`;
}

/** Open /profile scrolled to one availability pattern, which flashes as it arrives. */
export function availabilityPatternLinkFor(patternId: string): string {
  return `/profile#${availabilityPatternAnchorId(patternId)}`;
}
